export default require(`./${process.env.REACT_APP_PLATFORM}.json`)